import { GenericHeader, GenericFooter } from '@icij/murmur'

import ChartRoute from './ChartRoute'
import BanksResponseTime from '../components/BanksResponseTime.vue'
import DerwickAssociatesPayments from '../components/DerwickAssociatesPayments.vue'
import KolomoiskyProperties from '../components/KolomoiskyProperties.vue'
import LlpRise from '../components/LlpRise.vue'
import NumberOfSars from '../components/NumberOfSars.vue'
import ReasonsSarsMentionGold from '../components/ReasonsSarsMentionGold.vue'
import TopFiveBanks from '../components/TopFiveBanks.vue'
import TopTenBanksByAmountFiled from '../components/TopTenBanksByAmountFiled.vue'
import TopTenBanksByNumberFiled from '../components/TopTenBanksByNumberFiled.vue'
import TopGoldCompanies from '../components/TopGoldCompanies.vue'
import VenezuelanGovernment from '../components/VenezuelanGovernment.vue'
import Home from '../views/Home.vue'

export { guards } from './guards'
export { ChartRoute }
export const routes = [
  {
    path: '/',
    name: 'Home',
    props: {
      header: {
        noHeadroom: true,
        position: 'static'
      }
    },
    components: {
      header: GenericHeader,
      footer: GenericFooter,
      default: Home
    }
  },
  ChartRoute.create({ title: 'Gold companies in FinCEN Files (2007-2016)', chart: TopGoldCompanies }),
  ChartRoute.create({ title: 'Top 10 banks in FinCEN Files', chart: TopTenBanksByAmountFiled }),
  ChartRoute.create({ title: 'How long it takes banks to file a suspicious activity report', chart: BanksResponseTime }),
  // ChartRoute.create({ title: 'Legal action taken against the banks' }),
  ChartRoute.create({ title: 'Suspicious activity reports in FinCEN Files', chart: NumberOfSars }),
  // ChartRoute.create({ title: 'Number of Suspcious Activity Reports filed to FinCEN each year' }),
  // ChartRoute.create({ title: 'Top Correspondent connections by country' }),
  // ChartRoute.create({ title: 'Turnover analsys, by year' }),
  ChartRoute.create({ title: 'Venezuelan government entities found in FinCEN Files', chart: VenezuelanGovernment }),
  // ChartRoute.create({ title: 'Gold SARs as % of total SARS ($514,991,894,868.20 vs TBC)' }),
  ChartRoute.create({ title: 'Why SARs were filed mentioning gold companies', chart: ReasonsSarsMentionGold }),
  ChartRoute.create({ title: 'Derwick Associates payments found in FinCEN Files', chart: DerwickAssociatesPayments }),
  ChartRoute.create({ title: 'Ihor Kolomoisky\'s U.S. shopping spree', chart: KolomoiskyProperties }),
  ChartRoute.create({ title: 'Top 5 banks in FinCEN Files', chart: TopFiveBanks }),
  ChartRoute.create({ title: 'Rise in active LLPs and LPs in the UK', chart: LlpRise }),
  ChartRoute.create({ title: 'Top 10 banks in FinCEN Files by number of reports', chart: TopTenBanksByNumberFiled })
]
